import type { SVGProps } from "react";

type IconProps = SVGProps<SVGSVGElement> & { size?: number };

export function IconPhone({ size = 24, ...props }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
      <path d="M7.1 3.2 9.3 7l-2 1.8a15.5 15.5 0 0 0 7.9 7.9l1.8-2 3.8 2.2-.8 3a2 2 0 0 1-2.1 1.5C9.8 20.5 3.5 14.2 2.6 6.1A2 2 0 0 1 4.1 4l3-.8Z" />
    </svg>
  );
}

export function IconChat({ size = 24, ...props }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
      <path d="M4.2 17.3A8.4 8.4 0 1 1 7 20l-4 .8 1.2-3.5Z" />
      <circle cx="8.5" cy="11.7" r=".45" fill="currentColor" stroke="none" />
      <path d="M11.8 11.7h.4m3.3 0h.4" />
    </svg>
  );
}

export function IconCalendar({ size = 24, ...props }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
      <rect x="3" y="5" width="18" height="16" rx="2.5" />
      <path d="M7.5 3v4M16.5 3v4M3 9.5h18M8 13h.01M12 13h.01M16 13h.01M8 17h.01M12 17h.01" />
    </svg>
  );
}

export function IconRepeat({ size = 24, ...props }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
      <path d="M17.5 6.5H8a5 5 0 0 0-5 5v.5M14.5 3.5l3 3-3 3" />
      <path d="M6.5 17.5H16a5 5 0 0 0 5-5V12M9.5 20.5l-3-3 3-3" />
    </svg>
  );
}

export function IconReport({ size = 24, ...props }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
      <path d="M6 2.8h8l4 4V21H6a2 2 0 0 1-2-2V4.8a2 2 0 0 1 2-2Z" />
      <path d="M14 2.8v4h4M8 17v-3m3 3v-6m3 6v-4" />
    </svg>
  );
}

export function IconCheckCircle({ size = 24, ...props }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
      <circle cx="12" cy="12" r="9" />
      <path d="m8 12.2 2.6 2.6 5.7-6" />
    </svg>
  );
}

export function IconShieldCheck({ size = 24, ...props }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
      <path d="M12 2.5 20 6v5.7c0 4.7-3.2 8-8 9.8-4.8-1.8-8-5.1-8-9.8V6l8-3.5Z" />
      <path d="m8.5 11.8 2.2 2.2 4.8-5" />
    </svg>
  );
}

export function IconLock({ size = 24, ...props }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
      <rect x="4" y="10" width="16" height="11" rx="2.5" />
      <path d="M7.5 10V7a4.5 4.5 0 0 1 9 0v3M12 14.2v2.6" />
    </svg>
  );
}

export function IconCrown({ size = 24, ...props }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
      <path d="m3 7 4.5 4L12 4l4.5 7L21 7l-1.5 11h-15L3 7Z" />
      <path d="M5 21h14" />
    </svg>
  );
}

export function IconFlag({ size = 24, ...props }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
      <path d="M5 21V4m0 1h11.5l-1.7 3 1.7 3H5" />
    </svg>
  );
}

export function IconBuilding({ size = 24, ...props }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
      <path d="M3 21V8l2-5h14l2 5v13M3 8h18M8 21v-5h8v5" />
      <path d="M7 11v1m5-1v1m5-1v1M2 21h20" />
    </svg>
  );
}

export function IconHome({ size = 24, ...props }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
      <path d="m3 10 9-7 9 7v10a1 1 0 0 1-1 1h-5v-7H9v7H4a1 1 0 0 1-1-1V10Z" />
    </svg>
  );
}

export function IconMedicalCross({ size = 24, ...props }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
      <rect x="3" y="3" width="18" height="18" rx="4" />
      <path d="M12 7.5v9M7.5 12h9" />
    </svg>
  );
}

export function IconStethoscope({ size = 24, ...props }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
      <path d="M5 3v5a5 5 0 0 0 10 0V3M3 3h4m6 0h4M10 13v2.5a5.5 5.5 0 0 0 11 0V13" />
      <circle cx="19" cy="11" r="2" />
    </svg>
  );
}

export function IconScissors({ size = 24, ...props }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
      <circle cx="5.5" cy="6.5" r="2.5" />
      <circle cx="5.5" cy="17.5" r="2.5" />
      <path d="m7.8 7.5 12.7 7.3M7.8 16.5 20.5 9.2" />
    </svg>
  );
}

export function IconTeam({ size = 24, ...props }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
      <circle cx="9" cy="8" r="3" />
      <path d="M3.5 20v-1.5A5.5 5.5 0 0 1 9 13a5.5 5.5 0 0 1 5.5 5.5V20M15 5.3a3 3 0 0 1 0 5.4M17 13.4a5.5 5.5 0 0 1 3.5 5.1V20" />
    </svg>
  );
}

export function IconBot({ size = 24, ...props }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
      <rect x="3" y="7" width="18" height="13" rx="4" />
      <path d="M12 7V4m-3 10h.01m6 0h.01M8.5 17h7" />
      <circle cx="12" cy="3" r="1" />
    </svg>
  );
}

export function IconBolt({ size = 24, ...props }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
      <path d="M13.5 2.5 5 13h7l-1.5 8.5L19 11h-7l1.5-8.5Z" />
    </svg>
  );
}export function IconConsole({ size = 24, ...props }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
      <rect x="2.5" y="3.5" width="19" height="14" rx="2.5" />
      <path d="m6 13 3-3 2.5 2.5L16 8m-7 13h6m-3-3.5V21" />
    </svg>
  );
}

export function IconWrench({ size = 24, ...props }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
      <path d="M14.2 6.8a5 5 0 0 0-6.4 6.4l-5 5a2.1 2.1 0 0 0 3 3l5-5a5 5 0 0 0 6.4-6.4l-3 3-3-3 3-3Z" />
    </svg>
  );
}

export function IconPlug({ size = 24, ...props }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
      <path d="M8 3v5m8-5v5M6 8h12v2a6 6 0 0 1-6 6 6 6 0 0 1-6-6V8Zm6 8v5" />
    </svg>
  );
}

export function IconSearch({ size = 24, ...props }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
      <circle cx="10.5" cy="10.5" r="7" />
      <path d="m15.5 15.5 5 5" />
    </svg>
  );
}

export function IconHandshake({ size = 24, ...props }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
      <path d="m2.5 9 4-4 4 2 3-1.5L21.5 12l-2.7 2.7M6.5 16.5l2 2a2 2 0 0 0 2.8 0l.7-.7.7.7a2 2 0 0 0 2.8 0l3.3-3.8-5.3-4.2-2.2 1.8a2.5 2.5 0 0 1-3.5-.3l-.3-.4 3-4.6M2.5 9v5l4 2.5m15-4.5v-2" />
    </svg>
  );
}

export function IconMegaphone({ size = 24, ...props }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
      <path d="M4 10v4a2 2 0 0 0 2 2h2l2 5h3l-1.5-5H13l7 3V5l-7 3H6a2 2 0 0 0-2 2Z" />
      <path d="M13 8v8" />
    </svg>
  );
}

export function IconPhoto({ size = 24, ...props }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
      <rect x="3" y="3" width="18" height="18" rx="3" />
      <circle cx="15.5" cy="8.5" r="1.5" />
      <path d="m4 17 5-5 3.5 3.5 2-2L20 19" />
    </svg>
  );
}

export function IconSend({ size = 24, ...props }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
      <path d="M21 3 10 14m11-11-7 18-4-7-7-4 18-7Z" />
    </svg>
  );
}

export function IconMobile({ size = 24, ...props }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
      <rect x="6" y="2.5" width="12" height="19" rx="2.5" />
      <path d="M10 5h4m-2 13.5h.01" />
    </svg>
  );
}

export function IconClipboard({ size = 24, ...props }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
      <rect x="4" y="4.5" width="16" height="17" rx="2.5" />
      <path d="M9 5V3.5A1.5 1.5 0 0 1 10.5 2h3A1.5 1.5 0 0 1 15 3.5V5a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1Zm0 6h6m-6 4h6" />
    </svg>
  );
}

export function IconClock({ size = 24, ...props }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3.5 2" />
    </svg>
  );
}

export function IconPhoneOff({ size = 24, ...props }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
      <path d="M8.2 4.6 6.8 3.2a2 2 0 0 0-3 .2L2.5 5.2c-.6.8-.6 1.9-.2 2.8a25 25 0 0 0 13.6 13.6c.9.4 2 .4 2.8-.2l1.8-1.3a2 2 0 0 0 .2-3l-3.2-3.2a2 2 0 0 0-2.5-.3l-1.8 1.2a16 16 0 0 1-4-4M3 3l18 18" />
    </svg>
  );
}

export function IconPencilNote({ size = 24, ...props }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
      <path d="M13 4H5a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h13a2 2 0 0 0 2-2v-8" />
      <path d="m10 14 1-4 6.8-6.8a1.7 1.7 0 0 1 2.4 2.4L13.4 12 10 14Zm6.5-9.5 3 3" />
    </svg>
  );
}

export function IconTrendUp({ size = 24, ...props }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
      <path d="m3 17 6-6 4 4 8-9" />
      <path d="M15 6h6v6" />
    </svg>
  );
}

export function IconSparkle({ size = 24, ...props }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
      <path d="M12 2.5c.6 5.9 2.9 8.2 8.5 9.5-5.6 1.3-7.9 3.6-8.5 9.5-.6-5.9-2.9-8.2-8.5-9.5 5.6-1.3 7.9-3.6 8.5-9.5Z" />
    </svg>
  );
}

export function IconRupee({ size = 24, ...props }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
      <path d="M6 4h12M6 8h12M7 4h3.5a4 4 0 0 1 0 8H7l8 8" />
    </svg>
  );
}

export function IconXCircle({ size = 24, ...props }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
      <circle cx="12" cy="12" r="9" />
      <path d="m9 9 6 6m0-6-6 6" />
    </svg>
  );
}

export function IconMoon({ size = 24, ...props }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
      <path d="M20.5 15.5A9 9 0 0 1 8.5 3.4a9 9 0 1 0 12 12.1Z" />
    </svg>
  );
}
export function IconFilm({ size = 24, ...props }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
      <rect x="3" y="4" width="18" height="16" rx="2.5" />
      <path d="M7 4v16" />
      <path d="M17 4v16" />
      <path d="M3 9h4" />
      <path d="M3 15h4" />
      <path d="M17 9h4" />
      <path d="M17 15h4" />
      <path d="M11 9.5v5l3.5-2.5z" />
    </svg>
  );
}

export function IconPlay({ size = 24, ...props }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
      <circle cx="12" cy="12" r="9" />
      <path d="M10 8.5v7l5.5-3.5z" />
    </svg>
  );
}

export function IconMic({ size = 24, ...props }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
      <rect x="9" y="3" width="6" height="11" rx="3" />
      <path d="M5.5 11a6.5 6.5 0 0 0 13 0" />
      <path d="M12 17.5V21" />
      <path d="M8.5 21h7" />
    </svg>
  );
}

export function IconPalette({ size = 24, ...props }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
      <path d="M12 3a9 9 0 1 0 0 18h1.5a2.5 2.5 0 0 0 0-5H12a2 2 0 0 1-2-2c0-1.1.9-2 2-2h6.5A2.5 2.5 0 0 0 21 9.5 8.5 8.5 0 0 0 12 3z" />
      <circle cx="7.5" cy="11" r="0.5" fill="currentColor" stroke="none" />
      <circle cx="9.5" cy="7" r="0.5" fill="currentColor" stroke="none" />
      <circle cx="14" cy="6.5" r="0.5" fill="currentColor" stroke="none" />
    </svg>
  );
}

export function IconHeart({ size = 24, ...props }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
      <path d="M12 20.5C7.5 17 3.5 13.6 3.5 9.6 3.5 6.9 5.6 5 8 5c1.6 0 3 .8 4 2.2C13 5.8 14.4 5 16 5c2.4 0 4.5 1.9 4.5 4.6 0 4-4 7.4-8.5 10.9z" />
    </svg>
  );
}
